import { render, staticRenderFns } from "./shipping-summary.vue?vue&type=template&id=de193ee6"
import script from "./shipping-summary.vue?vue&type=script&lang=js"
export * from "./shipping-summary.vue?vue&type=script&lang=js"
import style0 from "./shipping-summary.vue?vue&type=style&index=0&id=de193ee6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports